import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { AccessibilityButton } from "@/components/AccessibilityButton";
import { ServicesHero, ServicesGrid, AdditionalServices, ServicesCTA } from "@/components/Services";
import { openGoogleCalendar } from "@/lib/utils";
import { usePageVisibility, PAGE_VISIBILITY_KEYS } from "@/hooks/usePageVisibility";
import { PageUnavailable } from "@/components/ui/PageUnavailable";

export default function Servicos() {
  const { isVisible } = usePageVisibility();
  const handleSchedule = () => { openGoogleCalendar(); };

  if (!isVisible(PAGE_VISIBILITY_KEYS.servicos)) {
    return <PageUnavailable />;
  }

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="pt-24">
          <ServicesHero />
          <ServicesGrid onSchedule={handleSchedule} />
          <div className="container mx-auto px-6 pb-16">
            <AdditionalServices onSchedule={handleSchedule} />
          </div>
          <ServicesCTA />
        </div>
        <Footer />
        <FloatingWhatsApp />
        <AccessibilityButton />
      </div>
    </>
  );
}
